import React from 'react';
import moment from 'moment';
import { Key } from '@philips-internal/oswald-ui-constants';
import { isFunction, trigger } from '@philips-internal/oswald-ui-utils';
import { DatePickerMode } from '../date-picker-constants.js';
function getTitle(mode, date) {
    const year = moment(date).format('YYYY');
    const month = moment(date).format('MMMM');
    const yearMinus11 = moment(date).utc().add(-11, 'year').format('YYYY');
    if (mode === DatePickerMode.DECADES) {
        return `${yearMinus11}-${year}`;
    }
    if (mode === DatePickerMode.YEARLY) {
        return year;
    }
    return `${month} ${year}`;
}
function DatePickerTimeSpan(props) {
    const { date, enableNext = true, enablePrev = true, mode, onArrowClick, onTitleClick, showNavigationArrows = true, } = props;
    const onNextClick = trigger(onArrowClick, 1);
    const onPrevClick = trigger(onArrowClick, -1);
    const title = getTitle(mode, date);
    const onKeyDown = (event, delta) => {
        if (event.key === Key.ENTER) {
            if (delta === 1) {
                onPrevClick();
            }
            else if (delta === -1) {
                onNextClick();
            }
            else if (isFunction(onTitleClick)) {
                onTitleClick();
            }
        }
    };
    return (React.createElement("div", { className: "c-date-picker__header" },
        enablePrev && showNavigationArrows &&
            React.createElement("div", { className: "c-date-picker__button c-date-picker__button--left", onClick: onPrevClick, onKeyDown: (event) => onKeyDown(event, -1), role: "button", tabIndex: 0 }),
        React.createElement("div", { className: "c-date-picker__title", onClick: onTitleClick, onKeyDown: (event) => onKeyDown(event, 0), tabIndex: 0 }, title),
        enableNext && showNavigationArrows &&
            React.createElement("div", { className: "c-date-picker__button c-date-picker__button--right", onClick: onNextClick, onKeyDown: (event) => onKeyDown(event, 1), role: "button", tabIndex: 0 })));
}
export { DatePickerTimeSpan, };
//# sourceMappingURL=date-picker-time-span.js.map